module.exports = __webpack_public_path__ + "static/FullStoryInitiative_Logo-335331cd02117c35ef61d9d9c837d3cf.png";